import { hasStoppedMessage } from "./streamState";

export type StreamPreviewUiState = "loading" | "error";

export { hasStoppedMessage };

export const warmImageObjectUrl = async (objectUrl: string): Promise<void> => {
  await new Promise<void>((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve();
    image.onerror = () => reject(new Error("unable to decode preview image"));
    image.src = objectUrl;
  });
};
